import { application } from 'services/core'

function PaymentFormsController () {
  const elements = {}
  const initializeSelectors = () => {
    elements.languageToggleButton = document.querySelector('#language-toggle')
  }

  const initializeListeners = () => {
    elements.languageToggleButton.addEventListener('click', toggleLanguage, false)
  }

  // TODO: Move the language toggle logic to a shared file
  // also, combine this logic with the one in frontend/.../static_forms/index.js
  const toggleLanguage = () => {
    const language = $('html').attr('lang') === 'ar' ? 'en' : 'ar'
    const switchLocaleUrl = new URL(window.global.LOCALE_SWITCHER_URL, window.location.origin)
    switchLocaleUrl.searchParams.append('language', language)

    fetch(switchLocaleUrl.href)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) { window.location.reload() }
      })
  }

  // TODO: Move to a shared file
  const convertNumber = (number) => {
    // PERSIAN, ARABIC, URDO
    number = number.replace(/[\u0660-\u0669]/g, function (d) { return d.charCodeAt(0) - 1632 })
    return number
  }

  return () => {
    // TODO: use a JS event listener over exposing to the DOM
    window.convertNumber = convertNumber

    initializeSelectors()
    initializeListeners()
  }
}

application.register(PaymentFormsController, import.meta)

export default PaymentFormsController

